export default __webpack_public_path__ + "static/experienceImg3-d600fabd878db1df4b0dbd2b3fc51751.webp";